<script setup lang="ts">
import { useId, ref, computed } from "vue";
import { useAccount } from "#/account/useAccount";
import { useModal } from "#/form/useModal";
import FormInput from "#/form/FormInput.vue";

interface Props {
  modalId?: string;
  hasPassword?: boolean;
}

const props = defineProps<Props>();

const { password, state } = useAccount();
const { close } = useModal();
const errorMessage = ref("");
let keyId = useId();

const isHasPasswordToBool = () => {
  return Boolean(Number(props.hasPassword));
};

const closeModal = () => {
  if (props.modalId) close(props.modalId);
};

const clearForm = () => {
  password.form.repeat = "";
  password.form.new = "";
  password.form.old = "";
};

const passwordErrors = computed(() => {
  const isPasswordsDifferent = () => {
    if (password.form.repeat) {
      return password.form.new !== password.form.repeat;
    }

    return false;
  };

  const isHasErrors = !!errorMessage.value || isPasswordsDifferent();

  return { isPasswordsDifferent, isHasErrors };
});

const buttonDisabled = computed(
  () => state.isLoading || passwordErrors.value.isPasswordsDifferent()
);

const save = async () => {
  try {
    await password.changePassword(password.form);
    closeModal();
    clearForm();
    window.location.reload();
  } catch (e: any) {
    errorMessage.value = e;
  }
};
</script>

<template :key="keyId">
  <form :key="keyId" class="mt-20" @submit.prevent="save">
    <form-input
      v-if="isHasPasswordToBool()"
      v-model="password.form.old"
      label="Введите старый пароль"
      placeholder="Введите действующий пароль"
      type="password"
      required
    />

    <form-input
      v-model="password.form.new"
      label="Введите новый пароль"
      placeholder="Введите новый пароль"
      type="password"
      required
    />

    <form-input
      v-model="password.form.repeat"
      label="Повторите пароль"
      placeholder="Повторите новый пароль"
      type="password"
      required
    />

    <div v-if="passwordErrors.isHasErrors" class="mt-12 color-error">
      <span v-if="passwordErrors.isPasswordsDifferent()" class="flex">
        Пароли должны совпадать
      </span>
      <span v-if="errorMessage" class="flex">
        {{ errorMessage }}
      </span>
    </div>

    <button
      type="submit"
      class="w-full mt-36 flex justify-center counter-form__submit btn"
      :class="buttonDisabled ? 'tag-disable' : 'tag-primary'"
      :disabled="buttonDisabled"
    >
      Изменить пароль
    </button>
  </form>
</template>
